function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Vue from 'vue';
import { Calendar } from '@fullcalendar/core';
import { CustomRenderingStore } from '@fullcalendar/core/internal';
import { OPTION_IS_COMPLEX } from './options.js';
import OffscreenFragment from './OffscreenFragment.js';
import TransportContainer from './TransportContainer.js';
var FullCalendar = Vue.extend({
  props: {
    options: Object
  },
  data: function data() {
    return {
      renderId: 0,
      customRenderingMap: new Map()
    };
  },
  methods: {
    getApi: function getApi() {
      return getSecret(this).calendar;
    },
    buildOptions: function buildOptions(suppliedOptions) {
      return Object.assign(Object.assign({}, suppliedOptions), {
        customRenderingMetaMap: kebabToCamelKeys(this.$scopedSlots),
        handleCustomRendering: getSecret(this).handleCustomRendering,
        customRenderingReplaces: true
      });
    }
  },
  render: function render(h) {
    var customRenderingNodes = [];

    var _iterator = _createForOfIteratorHelper(this.customRenderingMap.values()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var customRendering = _step.value;
        var innerContent = typeof customRendering.generatorMeta === 'function' ? customRendering.generatorMeta(customRendering.renderProps) : // a slot-render-function
        customRendering.generatorMeta; // jsx vnode?

        customRenderingNodes.push( // need stable element reference for list-diffing
        // TODO: move this functionality within TransportContainer
        h('div', {
          key: customRendering.id
        }, [h(TransportContainer, {
          key: customRendering.id,
          props: {
            inPlaceOf: customRendering.containerEl,
            reportEl: customRendering.reportNewContainerEl,
            elTag: customRendering.elTag,
            elClasses: customRendering.elClasses,
            elStyle: customRendering.elStyle,
            elAttrs: customRendering.elAttrs
          }
        }, innerContent)]));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return h('div', {
      // when renderId is changed, Vue will trigger a real-DOM async rerender, calling beforeUpdate/updated
      attrs: {
        'data-fc-render-id': this.renderId
      }
    }, [// for containing TransportContainer keys
    h(OffscreenFragment, customRenderingNodes)]);
  },
  mounted: function mounted() {
    var _this = this;

    var customRenderingStore = new CustomRenderingStore();
    getSecret(this).handleCustomRendering = customRenderingStore.handle.bind(customRenderingStore);
    var calendarOptions = this.buildOptions(this.options);
    var calendar = new Calendar(this.$el, calendarOptions);
    getSecret(this).calendar = calendar;
    calendar.render();
    customRenderingStore.subscribe(function (customRenderingMap) {
      _this.customRenderingMap = customRenderingMap; // likely same reference, so won't rerender

      _this.renderId++; // force rerender

      getSecret(_this).needCustomRenderingResize = true;
    });
  },
  beforeUpdate: function beforeUpdate() {
    this.getApi().resumeRendering(); // the watcher handlers paused it
  },
  updated: function updated() {
    if (getSecret(this).needCustomRenderingResize) {
      getSecret(this).needCustomRenderingResize = false;
      this.getApi().updateSize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.getApi().destroy();
  },
  watch: buildWatchers()
});
export default FullCalendar; // storing internal state:
// https://github.com/vuejs/vue/issues/1988#issuecomment-163013818

function getSecret(inst) {
  return inst;
}

function buildWatchers() {
  var watchers = {
    // watches changes of ALL options and their nested objects,
    // but this is only a means to be notified of top-level non-complex options changes.
    options: {
      deep: true,
      handler: function handler(options) {
        var calendar = this.getApi();
        calendar.pauseRendering();
        var calendarOptions = this.buildOptions(options);
        calendar.resetOptions(calendarOptions);
        this.renderId++; // will queue a rerender
      }
    }
  };

  var _loop = function _loop(complexOptionName) {
    // handlers called when nested objects change
    watchers["options.".concat(complexOptionName)] = {
      deep: true,
      handler: function handler(val) {
        // unfortunately the handler is called with undefined if new props were set, but the complex one wasn't ever set
        if (val !== undefined) {
          var calendar = this.getApi();
          calendar.pauseRendering();
          calendar.resetOptions(_defineProperty({}, complexOptionName, val), [complexOptionName]);
          this.renderId++; // will queue a rerender
        }
      }
    };
  };

  for (var complexOptionName in OPTION_IS_COMPLEX) {
    _loop(complexOptionName);
  }

  return watchers;
} // General Utils


function kebabToCamelKeys(map) {
  var newMap = {};

  for (var key in map) {
    newMap[kebabToCamel(key)] = map[key];
  }

  return newMap;
}

function kebabToCamel(s) {
  return s.split('-').map(function (word, index) {
    return index ? capitalize(word) : word;
  }).join('');
}

function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}